const travelRequestHeaders = {
  RequestNo: 'Request No.',
  TravelDate: 'Travel Date',
  TravelDestination: 'Travel Destination',
  TravelPurpouse: 'Travel Purpose',
  Status: 'Status',
};

const bookingCategoryOptions = ['New', 'Rebooking', 'Cancellation'];

export { travelRequestHeaders, bookingCategoryOptions };
